import { createStorefrontApiClient } from '@shopify/storefront-api-client';
import { SHOPIFY_STORE_DOMAIN, SHOPIFY_PUBLIC_ACCESS_TOKEN, SHOPIFY_VERSION } from '../actions/constats';
const client = createStorefrontApiClient({
    storeDomain: SHOPIFY_STORE_DOMAIN,
    apiVersion: SHOPIFY_VERSION,
    publicAccessToken: SHOPIFY_PUBLIC_ACCESS_TOKEN,
});
export default client;
